// this is an autogenerated file from App/Account/Content/Tasks/mutation-update-task-priority.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks(
  $task_id: uuid!
  $priority: tasks_priorities_enum!
) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: { priority: $priority }
  ) {
    id
  }
}

`